import axios from 'axios';
import AuthService from './AuthService';

class UsuarioSecundarioService {
    constructor() {
        this.apiUrl = process.env.REACT_APP_API_URL || 'https://portalrelacionamentoapi.dev-gam.com';
    }

    async headers() {
        if (!AuthService.getToken()) {
            await AuthService.login();
        }
        return { Authorization: `Bearer ${AuthService.getActiveToken()}` };
    }

    async listarModulos() {
        const response = await axios.get(`${this.apiUrl}/modulos`, { headers: await this.headers() });
        return response.data.conteudo;
    }

    async listarPorMaster(cdUsuarioMaster) {
        const response = await axios.get(`${this.apiUrl}/usuarios-secundarios/${cdUsuarioMaster}`, {
            headers: await this.headers(),
        });
        return response.data.conteudo;
    }

    // RN006: o login é gerado pelo backend, não é mais enviado aqui.
    async buscarProximoLogin(cdUsuarioMaster) {
        const response = await axios.get(`${this.apiUrl}/usuarios-secundarios/${cdUsuarioMaster}/proximo-login`, {
            headers: await this.headers(),
        });

        if (response.data.status !== 'OK') {
            throw new Error(response.data.mensagem || 'Não foi possível gerar o login.');
        }

        return response.data.conteudo;
    }

    async criar({ cdUsuarioMaster, dsSenha, dsEmail, nmUsuario, atribuicoes }) {
        const response = await axios.post(
            `${this.apiUrl}/usuarios-secundarios`,
            { cdUsuarioMaster, dsSenha, dsEmail, nmUsuario, atribuicoes },
            { headers: await this.headers() }
        );

        if (response.data.status !== 'OK') {
            throw new Error(response.data.mensagem || 'Erro ao criar usuário secundário.');
        }

        return response.data.conteudo;
    }

    async buscarDetalhe(cdUsuarioMaster, cdUsuario) {
        const response = await axios.get(`${this.apiUrl}/usuarios-secundarios/${cdUsuarioMaster}/${cdUsuario}`, {
            headers: await this.headers(),
        });

        if (response.data.status !== 'OK') {
            throw new Error(response.data.mensagem || 'Não foi possível carregar o usuário.');
        }

        return response.data.conteudo;
    }

    async atualizarDados(cdUsuario, { cdUsuarioMaster, nmUsuario, dsEmail, novaSenha }) {
        const response = await axios.put(
            `${this.apiUrl}/usuarios-secundarios/${cdUsuario}`,
            { cdUsuarioMaster, nmUsuario, dsEmail, novaSenha },
            { headers: await this.headers() }
        );

        if (response.data.status !== 'OK') {
            throw new Error(response.data.mensagem || 'Erro ao atualizar dados do usuário.');
        }
    }

    async atualizarAtribuicoes(cdUsuario, { cdUsuarioMaster, atribuicoes }) {
        const response = await axios.put(
            `${this.apiUrl}/usuarios-secundarios/${cdUsuario}/atribuicoes`,
            { cdUsuarioMaster, atribuicoes },
            { headers: await this.headers() }
        );

        if (response.data.status !== 'OK') {
            throw new Error(response.data.mensagem || 'Erro ao atualizar CNPJs/módulos do usuário.');
        }
    }

    async atualizarStatus(cdUsuario, cdUsuarioMaster, ativo) {
        const response = await axios.patch(
            `${this.apiUrl}/usuarios-secundarios/${cdUsuario}/status`,
            { cdUsuarioMaster, ativo },
            { headers: await this.headers() }
        );

        if (response.data.status !== 'OK') {
            throw new Error(response.data.mensagem || 'Erro ao atualizar status do usuário.');
        }

        return response.data;
    }
}

export default new UsuarioSecundarioService();
